import key from 'weak-key';
import { Col, Row } from '@geberit/gdds';

// styles
import styles from './media-tiles.module.scss';

// types
import type { MediaTilesProps, RelatedMaterialsDisplayMode } from '../types/press-portal.types';
import type { Media } from '../types/mynewsdesk.types';

// components
import { MediaTile } from './media-tile';
import { TilesHeadline } from '../tiles-headline';

// utils
import { getMaterialUniqueIdentifier } from '../utils';
import { useIsMobile } from 'components/App/SizeProvider';
import { useTranslationByKey } from 'utils/hooks/use-translations';
import { isEmpty } from 'utils/is-empty';
import { classNameBuilder } from 'utils/classNameBuilder';

export default function RelatedMediaTiles({ mediaList }: Readonly<MediaTilesProps>) {
  const isMobile = useIsMobile();
  const pressRelatedMaterials = useTranslationByKey('press_related_materials');

  if (isEmpty(mediaList)) return null;

  const relatedMaterialsDisplayMode: RelatedMaterialsDisplayMode =
    mediaList.length > 2 ? 'three_per_row' : 'two_per_row';

  return (
    <>
      <TilesHeadline translation={pressRelatedMaterials} />
      <Row className={styles.relatedMaterialsWrapper}>
        {relatedMaterialsDisplayMode === 'two_per_row' && <Col size={[0, 0, 2]}></Col>}
        <Col size={[4, 8, relatedMaterialsDisplayMode === 'two_per_row' ? 8 : 12]}>
          <div
            className={classNameBuilder(
              styles.mediaTilesWrapper,
              relatedMaterialsDisplayMode === 'two_per_row' && styles.twoTilesPerRow,
            )}
          >
            {mediaList.map((media: Media) => {
              return (
                <MediaTile
                  path={`?page=asset-detailpage&title=${getMaterialUniqueIdentifier(media)}`}
                  key={key(media)}
                  isMobile={isMobile}
                  media={media}
                />
              );
            })}
          </div>
        </Col>
        {relatedMaterialsDisplayMode === 'two_per_row' && <Col size={[0, 0, 2]}></Col>}
      </Row>
    </>
  );
}
